<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Checklist de Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklF02804">
                                <strong>Relatório Físico </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02804">
                                <strong>Relatório Físico </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02805">
                                <strong
                                    >Demonstrativo Sintético
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(1)"
                                ></strong>
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02805">
                                <strong
                                    >Demonstrativo Sintético
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(1)"
                                ></strong>
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02806">
                                <strong
                                    >Relação de Pagamentos
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(2)"
                                ></strong>
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02806">
                                <strong
                                    >Relação de Pagamentos
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(2)"
                                ></strong>
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>
                        </b-row>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklF02807">
                                <strong
                                    >Rel de Pagamentos Parceiros
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(3)"
                                ></strong>
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02807">
                                <strong
                                    >Rel de Pagamentos Parceiros
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(3)"
                                ></strong>
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02808">
                                <strong
                                    >Rel Despesas Econômicas Parceiros
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02808">
                                <strong
                                    >Rel Despesas Econômicas Parceiros
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklF02809">
                                <strong
                                    >Declaração Compras Contratações 
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklF02809">
                                <strong
                                    >Declaração Compras Contratações 
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button" disabled></strong-->
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>
                        </b-row>
                        <b-row class="pb-2">
                            <b-col v-if="!convenio.cklExtratoBancario">
                                <strong>Extratos Bancários </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(4)"
                                ></strong>
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklExtratoBancario">
                                <strong>Extratos Bancários </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button"
                                    @click.stop="imprimir(4)"
                                ></strong>
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col
                                v-if="!convenio.cklExtratoBancarioAplFinanceira"
                            >
                                <strong
                                    >Extratos Bancários de Aplicação Financeira
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col
                                v-if="convenio.cklExtratoBancarioAplFinanceira"
                            >
                                <strong
                                    >Extratos Bancários de Aplicação Financeira
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong -->
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>

                            <b-col v-if="!convenio.cklAporteRecParceiros">
                                <strong
                                    >Declaração de Aporte de Recursos de
                                    Parceiro
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong -->
                                <strong
                                    class="fa fa-window-close fa-lg icon-button"
                                    style="color: red"
                                ></strong>
                            </b-col>
                            <b-col v-if="convenio.cklAporteRecParceiros">
                                <strong
                                    >Declaração de Aporte de Recursos de
                                    Parceiro
                                </strong>
                                <!--strong class="fa fa-print fa-lg icon-button"></strong-->
                                <strong
                                    class="fa fa-check-square fa-lg"
                                    style="color: #3adf00"
                                ></strong>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <b-card no-body>
            <b-card-header>
                <span class="h5"> Prestação de Contas Final </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        :itens="lista"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false"
                    >
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <Cadastro
                                    v-if="
                                        $temAcessoView('CONV-FIN-01') &&
                                        convenio.idSituacaoConvenio != 9
                                    "
                                    class="mr-2"
                                    @atualizarCadastro="atualizarCadastro()"
                                    :parentData="convenio"
                                    :modoCadastro="true"
                                >
                                </Cadastro>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                            <span class="text-danger float-left mr-1">
                                <i
                                    class="fa fa-trash fa-lg icon-button"
                                    title="Excluir Documento"
                                    v-if="
                                        $temAcessoView('CONV-00') &&
                                        convenio.idSituacaoConvenio != 9
                                    "
                                    @click.stop="confirmarExclusao(data)"
                                ></i>
                            </span>
                            <span class="text-primary float-left mr-1">
                                <Cadastro
                                    class="mr-2"
                                    v-if="
                                        $temAcessoView('CONV-FIN-02') &&
                                        convenio.idSituacaoConvenio != 9
                                    "
                                    @atualizarCadastro="atualizarCadastro()"
                                    :parentData="convenio"
                                    :modoCadastro="false"
                                    :documento="data"
                                >
                                </Cadastro>
                            </span>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>

        <b-modal
            id="modalDoc"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            style="height: 50%; margin: 0"
        >
            <div slot="modal-title">Visualizar Documentos - {{ nomeDoc }}</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <iframe
                v-if="arquivo"
                v-bind:src="arquivo"
                style="width: 100%; height: 600px"
            >
            </iframe>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import Cadastro from '../cadastro/BtnDocumentoPrestacaoContasFinal.vue'

export default {
    components: {
        Cadastro
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            itensPorPagina: 5,
            lista: [],

            mostrarModal: false,
            arquivo: [],
            nomeDoc: '',

            campos: [
                {
                    key: 'documentoPrestacaoContas.descricao',
                    label: 'Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcObservacoes',
                    label: 'Observação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.arquivo = null
        },

        atualizarLista() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarDocumentoPrestacaoContasConvenio(
                this.convenio.idConvenio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.lista = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarExclusao(obj) {
            this.$swal({
                title: 'Excluir',
                html:
                    'Deseja Excluir o Documento: <strong>' +
                    obj.documentoPrestacaoContas.descricao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(obj)
                }
            })
        },

        excluir(obj) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.DeletarDocumentoPrestacaoContasConvenio(obj).then(
                (response) => {
                    if (response) {
                        this.$emit('atualizarDadosConvenio')
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarCadastro() {
            this.$emit('atualizarDadosConvenio')
        },

        imprimir(id) {
            if (id == 1) {
                this.RelatorioF02805()
            } else if (id == 2) {
                this.RelatorioF02806()
            } else if (id == 3) {
                this.RelatorioF02807()
            } else if (id == 4) {
                this.RelatorioExtratoPrestacaoContas()
            }
        },

        RelatorioF02805() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02805DemonstrativoExecucaoSintetico(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/05')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        RelatorioF02806() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF02806RelacaoPagamentosEfetuados(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/06')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        RelatorioF02807() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatorio F028/07')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        RelatorioExtratoPrestacaoContas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.RelatorioExtratoPrestacaoContas(
                this.convenio.idConvenio,
                1
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(
                            response,
                            'Relatorio Extrato de Prestação de Contas'
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        visualizar(doc, nome) {
            this.nomeDoc = nome
            const blob = new Blob([doc], { type: 'application/pdf' })
            this.arquivo = window.URL.createObjectURL(blob)
            this.mostrarModal = true
        }
    },

    watch: {
        convenio() {
            if (this.convenio) {
                this.atualizarLista()
            }
        }
    }
}
</script>
